module.exports = __webpack_public_path__ + "img/forgot.8317f8c9.jpg";